import React, { ReactNode } from 'react';

interface PanelContainerProps {
    children: ReactNode;
}

function PanelContainer({ children }: PanelContainerProps): React.JSX.Element {
    return <div className="bg-muted flex flex-col items-start rounded-md p-2.5">{children}</div>;
}

export default PanelContainer;
